<i *ngIf="!phxLoading" phx-icon [phxIcon]="phxIcon" [size]="iconSize" color="currentColor"></i>
<i *ngIf="phxLoading" phx-icon [phxIcon]="CircleLoadingIcon" [size]="iconSize" color="currentColor" class="phx-icon-button-loading-icon"></i>
